<rp-balance-card [title]="'finance.myBalance' | translate" [value]="balance().available + balance().onHold | centsToDollarsPipe" />
<rp-balance-card [title]="'finance.available' | translate" [value]="balance().available | centsToDollarsPipe" />
<rp-balance-card [title]="'finance.onHold' | translate" [value]="balance().onHold | centsToDollarsPipe" />
<rp-payout-card (getPayouts)="onGetPayouts()" />
